import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TmpPlayer } from '../../templates/tmp-player/tmp-player';

@Component({
  selector: 'app-players',
  imports: [TmpPlayer],
  templateUrl: './players.html',
  styleUrl: './players.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Players { 
  players = input<any>();
  turning = input<number>(0);
  type = input();

  sortedPlayers = computed(() => {
    const list = Array.isArray(this.players()) ? [...this.players()] : [];

    return list.sort((a: any, b: any) => {
      const left = Number(a?.successesInGame ?? 0);
      const right = Number(b?.successesInGame ?? 0);
      return right - left;
    });
  });
}
